import { useMemo } from 'react';

import {
  GoogleIntegrationStatus,
  MessagingPlatform,
  UserCommunication,
} from '@this+that/models';

import { useGetUserGoogleChatAccounts } from '../../services/googleChat.service';

export function findGoogleChatAccountEmail(
  accounts: Pick<GoogleIntegrationStatus, 'gmailAddress'>[],
  userEmailAddress?: string | null,
): string | undefined {
  if (!userEmailAddress) {
    return undefined;
  }

  const target = userEmailAddress.toLowerCase();
  return accounts.find(
    (account) => account.gmailAddress?.toLowerCase() === target,
  )?.gmailAddress;
}

export function useGoogleChatAccountEmail(
  communication: UserCommunication,
): string | undefined {
  const { googleChatAccounts } = useGetUserGoogleChatAccounts();

  return useMemo(() => {
    if (communication.platform !== MessagingPlatform.GOOGLE_CHAT) {
      return undefined;
    }

    return findGoogleChatAccountEmail(
      googleChatAccounts,
      communication.userEmailAddress,
    );
  }, [
    communication.platform,
    communication.userEmailAddress,
    googleChatAccounts,
  ]);
}
